module.exports = __webpack_public_path__ + "img/icon-min-zwart.ac1531e563d052647799106dcdcf1e35.svg";